import { NavItem } from '@ukam/shell/layouts/full/vertical/sidebar/nav-item/nav-item';

export const adminNav: NavItem[] = [
  { navCap: 'Admin' },
  { displayName: 'Units', iconName: 'solar:suitcase-linear', route: '/admin/units' },
  { displayName: 'Partners', iconName: 'solar:user-broken', route: '/admin/partners' },
  { displayName: 'Branchs', iconName: 'solar:shop-minimalistic-linear', route: '/admin/branchs' },
  { displayName: 'Agents', iconName: 'solar:user-outline', route: '/admin/agents' },
  { displayName: 'Payroll Entities', iconName: 'solar:money-bag-outline', route: '/admin/payroll-entities' },
  { displayName: 'Settings', iconName: 'solar:settings-outline', route: '/admin/settings' },
  { displayName: 'Managers', iconName: 'solar:user-circle-linear', route: '/admin/managers' },
  { displayName: 'Users', iconName: 'solar:user-id-outline', route: '/admin/users' },
  { displayName: 'API Keys', iconName: 'solar:key-minimalistic-square-linear', route: '/admin/api-users' },
  { displayName: 'User Profiles', iconName: 'solar:shield-user-outline', route: '/admin/user-profiles' },
  { displayName: 'Attributes', iconName: 'solar:widget-2-outline', route: '/admin/attributes' },
  {
    displayName: 'Storages',
    iconName: 'solar:database-linear',
    route: '/admin/storages'
  },
  {
    displayName: 'Events',
    iconName: 'solar:bolt-circle-linear',
    children: [
      { displayName: 'Monitor', iconName: 'solar:pulse-linear', route: '/admin/events' },
      { displayName: 'Subscriptions', iconName: 'solar:link-circle-linear', route: '/admin/event-subscriptions' },
    ],
  },
  {
    displayName: 'Webhooks',
    iconName: 'solar:inbox-in-linear',
    children: [
      { displayName: 'Requests', iconName: 'solar:inbox-archive-linear', route: '/admin/webhook-requests' },
      { displayName: 'Endpoints', iconName: 'solar:server-path-linear', route: '/admin/webhook-endpoints' },
      { displayName: 'Keys', iconName: 'solar:key-minimalistic-linear', route: '/admin/webhook-keys' },
    ],
  },
  { displayName: 'Jobs', iconName: 'solar:cpu-bolt-linear', route: '/admin/jobs' },
  {
    displayName: 'Loans',
    iconName: 'solar:clipboard-text-linear',
    children: [
      { displayName: 'Products', iconName: 'solar:calculator-minimalistic-outline', route: '/admin/loan-products' },
    ],
  },
];
